import React from 'react';
import PropTypes from 'prop-types';
import NextLink from 'next/link';
import { withRouter } from 'next/router';

import { isExternal } from '../../modules/externalLink';

const Link = ({ router, href, as, children, className = '', ...props }) => {
  const isActive = router.asPath.includes(href) || router.asPath.includes(as);

  if (isExternal(href)) {
    return (
      <a
        href={href}
        className={isActive ? `${className} active` : className}
        {...props}
      >
        {children}
      </a>
    );
  } else {
    // Prefetch should be disabled on Next Links on this project as there is too much data to prefetch, some of which coming from APIs with rate limiting.
    return (
      <NextLink href={href} as={as} prefetch={false} legacyBehavior>
        <a className={isActive ? `${className} active` : className} {...props}>
          {children}
        </a>
      </NextLink>
    );
  }
};

Link.propTypes = {
  href: PropTypes.string.isRequired,
  as: PropTypes.string,
  children: PropTypes.node,
  className: PropTypes.string,
};

export default withRouter(Link);
